import React from "react";

const TextInputColumnFilter = ({ column }) => {
  const { filterValue, setFilter, placeholder, Header } = column;
  return (
    <>
      <input
        className="form-control form-control-sm ml-2 mr-2"
        placeholder={placeholder || Header}
        value={filterValue || ""}
        onChange={(e) => setFilter(e.currentTarget.value)}
      />
    </>
  );
};

export default TextInputColumnFilter;
